import React from 'react';
import { useEffect, useState } from 'react';
import styles from './MisReportsGraphs.module.scss';
import ReactECharts from 'echarts-for-react';
import { commonVaribles } from 'src/constants/constVariables';

const AnnualRecommendations = ({ annualRecommendationsData }) => {
	const [chartOptions, setChartOptions] = useState({});

	const getChartOptions = () => {
		return {
			title: {
				text: 'Annual Recommendations',
				left: 'left',
				textStyle: {
					color: '#000000', // Set title text color to black
					fontFamily: 'OpensansRegular',
				},
			},
			tooltip: {
				trigger: 'axis',
				axisPointer: {
					type: 'shadow',
				},
			},
			legend: {
				data: ['Recommendation Count', 'Count'],
				right: '1%',
				orient: 'vertical',
			},
			xAxis: [
				{
					type: 'category',
					data: annualRecommendationsData?.header_array,
					splitLine: {
						show: false, // Hide the separation line along the x-axis
					},
					axisLabel: {
						width: 130,
						rotate: 40,
						interval: 0,
					},
				},
			],
			yAxis: [
				{
					type: 'value',
					splitLine: {
						show: false, // Hide the grid lines on the y-axis
					},
					axisLine: {
						show: true, // Show y-axis line
					},
				},
			],
			grid: {
				backgroundColor: '#FFFF00', // Set the background color of the grid
			},
			series: [
				{
					name: 'Recommendation Count',
					type: 'bar',
					data: annualRecommendationsData?.total_recommended_sheet_cost_array,
					barGap: '50%', // Set the gap between bars
					barWidth: window.innerWidth <= 600 ? 15 : 30,
					itemStyle: {
						color: {
							type: 'linear',
							x: 0,
							y: 0,
							x2: 0,
							y2: 1,
							colorStops: [
								{ offset: 0, color: '#79D0F1' },
								{ offset: 0.5, color: '#74B0FA' },
								{ offset: 1, color: '#817AF3' },
							],
						},
						barBorderRadius: 10,
						borderWidth: 1,
					},
					label: {
						show: true, // Show label on top of the bar
						position: 'top', // Position the label on top of the bar
						color: 'black', // Label color
						fontSize: '12%', // Label font size
					},
				},
			],
		};
	};

	useEffect(() => {
		setChartOptions(getChartOptions());

		// Update chart options on window resize
		const handleResize = () => {
			setChartOptions(getChartOptions());
		};

		window.addEventListener('resize', handleResize);

		// Cleanup event listener on component unmount
		return () => {
			window.removeEventListener('resize', handleResize);
		};
	}, [annualRecommendationsData]);

	return (
		<>
			{annualRecommendationsData?.header_array ? (
				<ReactECharts
					option={chartOptions}
					notMerge={true}
					className={styles['chart']}
				/>
			) : (
				<div className={styles.containers}>{commonVaribles.data_not_found}</div>
			)}
		</>
	);
};

export default AnnualRecommendations;
